<template>
	<v-container class="d-flex flex-column justify-center align-center pa-4">
		<v-chip
			:id="id"
			class="nodata-chip"
			:data-test="`${error ? 'error' : loading ? 'loading' : 'no-data'}-chip`"
		>
			<v-avatar start>
				<v-icon size="x-small"
					>{{
						error
							? 'fal fa-bug'
							: loading
								? 'fal fa-sync fa-spin'
								: 'fal fa-database'
					}}
				</v-icon>
			</v-avatar>

			{{
				error
					? t('component.nodata.error')
					: loading
						? t('component.nodata.loading')
						: t('component.nodata.no_data')
			}}
		</v-chip>
	</v-container>
</template>

<script>
import { useI18n } from 'vue-i18n'

export default {
	name: 'NoData',
	props: {
		loading: {
			required: true,
			type: Boolean,
		},
		error: {
			required: false,
			type: Boolean,
		},
		name: {
			required: false,
			type: String,
			default: '',
		},
	},
	data: () => ({
		id: `nodata__${Date.now()}`,
		t: useI18n().t,
	}),
	mounted() {
		let parent = document.getElementById(this.id)?.closest('td')
		if (!parent) {
			return
		}
		parent.colSpan = 12
	},
}
</script>

<style lang="scss" scoped>
/* Ersetzt `bg-grey-lighten-4`. Das war ein fester Grauwert: bei einem Mandanten
   mit farbigem Hintergrund stand die Meldung als graue Insel in der Flaeche,
   und im dunklen Theme als heller Fleck. Die Stufe kommt jetzt aus derselben
   Leiter wie Tabellenkopf und Zebra, damit ein leerer Zustand aussieht wie eine
   Tabelle ohne Zeilen und nicht wie ein Fehler. */
.nodata-chip {
	background-color: var(--tenant-surface-2);
}
</style>
